import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import get from 'lodash/get'

import DefaultSection from 'components/config/quote/DefaultSection'

import { getBestProgram, getQuote } from 'selectors/quoteSelectors'
import { changeQuote, addItem, removeItem } from 'actions/quoteActions'

import { getSections } from 'components/config/quote/sections'

import { Flipper, Flipped } from 'react-flip-toolkit'

import './Survey.scss'
import './QuoteValueSelector.scss'

export const TITLES = {
  loan: 'Customize your Loan Payment',
  lease: 'Customize your Lease Payment',
}

export function Survey(props) {
  let {
      quoteId,
      vehicleId,
      mode,
      customer,
      changeQuote,
      addItem,
      removeItem,
      withConfig,
      quote,
      hideOptions,
      showCustomDown,
    } = props,
    onChange = ({ valueKey }, isString) => v => {
      let val = get(v, 'value', v)

      changeQuote(
        vehicleId,
        quoteId,
        {
          [valueKey]: !isString ? parseFloat(val, 0) : val,
        },
        { forceProgramUpdate: typeof v.value === 'undefined', squeeze: true }, // if it's a custom val, just repull
      )
    },
    addConfigItem = collection =>
      addItem(vehicleId, quoteId, collection, { label: '', value: '' }),
    removeConfigItem = (idx, collection) => {
      removeItem(vehicleId, quoteId, idx, collection)
    },
    editValue = collection => (idx, key, val) => {
      changeQuote(
        vehicleId,
        quoteId,
        {
          [`${collection}[${idx}].${key}`]: val,
        },
        { squeeze: true },
      )
    },
    configSections = getSections({ editValue })

  const sections = [
    {
      valueKey: 'leaseTerm',
      valuesKey: 'leaseTerms',
      hide: customer && mode && mode !== 'lease',
      label: (
        <span>
          How many <strong>Months</strong> do you want to drive this car?{' '}
          {withConfig && '(Lease only)'}
        </span>
      ),
    },
    {
      valueKey: 'loanTerm',
      valuesKey: 'loanTerms',
      hide: customer && mode && mode !== 'loan',
      label: (
        <span>
          How many <strong>Months</strong> do you want to drive this car?{' '}
          {withConfig && '(Loan only)'}
        </span>
      ),
    },
    {
      valueKey: 'miles',
      valuesKey: 'mileages',
      label: (
        <span>
          How many <strong>Miles Per Year</strong> do you drive?
        </span>
      ),
    },
    {
      valueKey: 'creditScore',
      valuesKey: 'creditTiers',
      label: (
        <span>
          How is your <strong>Credit</strong>?
        </span>
      ),
    },
    {
      valueKey: 'down',
      valuesKey: 'downs',
      customFieldLabel: 'Enter a custom amount down',
      allowCustom: showCustomDown,
      onCustomClose: () =>
        changeQuote(
          vehicleId,
          quoteId,
          {
            down: get(quote, 'downs[0].value', 0),
          },
          { squeeze: true },
        ),
      onCustomChange: down =>
        changeQuote(vehicleId, quoteId, { down }, { dirty: true }),
      label: (
        <span>
          How much can you <strong>Put Down</strong>?
        </span>
      ),
    },
  ]

  let sectionComps =
    !hideOptions &&
    sections
      .filter(s => !s.hide)
      .map(s => (
        <Flipped key={s.valueKey} flipId={s.valueKey} stagger>
          <div className="quote-value-selector">
            <DefaultSection
              {...props}
              {...s}
              showDiff
              onChange={onChange(s)}
              onCustomBlur={onChange(s)}
              selected={get(quote, s.valueKey)}
              collectionHeaders={configSections[s.valuesKey].headers}
              itemRenderer={configSections[s.valuesKey].renderer(s.valuesKey)}
              addItem={() => addConfigItem(s.valuesKey)}
              removeItem={idx => removeConfigItem(idx, s.valuesKey)}
            >
              {s.children}
            </DefaultSection>
          </div>
        </Flipped>
      ))

  return (
    <div
      className={c('easy-pencil-body', 'survey-wrapper', {
        hidden: hideOptions,
      })}
    >
      <div className="survey-inner">
        {mode !== 'cash' && (
          <Flipper
            className="easy-pencil-row survey-questions"
            flipKey={sections
              .filter(s => !s.hide)
              .map(s => s.valueKey)
              .join()}
          >
            {sectionComps}
          </Flipper>
        )}
      </div>
    </div>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    program: getBestProgram(state, op.vehicleId, op.quoteId, op.mode),
    quote: getQuote(state, op.vehicleId, op.quoteId),
    showCustomDown: op.customer,
  }
}

export default connect(
  mapStateToProps,
  { changeQuote, addItem, removeItem },
)(Survey)
